module.exports = __webpack_public_path__ + "img/gamemode.66c16bb8.png";